import React from 'react';
import { Row } from 'react-table';
import {
  MapData,
  PortfolioTransactionsTableSign,
  TransactionsColumnsType,
  getColumns,
} from 'modules/UserTransactionsTable/UserTransactionsTable.columns';
import { PortfolioTransactionsType } from 'services/requests';
import Table from 'components/Table';
import EmptyPage from 'components/EmptyPage';

import messages from './RenderOpenOrdersTable.messages';

type Props = {
  columns: TransactionsColumnsType[];
  transactionsListData?: PortfolioTransactionsType;
  items?: MapData;
  onAssetClick: (row: Row<PortfolioTransactionsTableSign>) => void;
};

const RenderOpenOrdersTable: React.FC<Props> = ({
  columns,
  transactionsListData,
  items,
  onAssetClick,
}) => (
  <Table<PortfolioTransactionsTableSign>
    columns={getColumns(columns)}
    data={items ?? []}
    onRowClick={onAssetClick}
    shouldShowCustomBody={transactionsListData && items?.length === 0}
    customBody={
      <>
        <EmptyPage message={messages.noTransactions} />
      </>
    }
  />
);

export default RenderOpenOrdersTable;
